import React, { useState } from 'react'
import { FaMapMarkedAlt, FaWaze } from 'react-icons/fa'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import '../styles/LocationSection.css'
import L from 'leaflet' // Import Leaflet
import markerIconPng from 'leaflet/dist/images/marker-icon.png' // Import Marker Icon
import markerShadowPng from 'leaflet/dist/images/marker-shadow.png' // Import Marker Shadow
import { T } from './Translation'
import parkingMap from '../assets/parkingMap.png';

function LocationSection({ eventInfo, wazeLink }) {
  const [isImageZoomed, setIsImageZoomed] = useState(false)
  const lat = parseFloat(eventInfo.eventLat)
  const lng = parseFloat(eventInfo.eventLng)

  const customMarker = new L.Icon({
    iconUrl: markerIconPng, // Marker image
    shadowUrl: markerShadowPng, // Marker shadow
    iconSize: [25, 41], // Default size
    iconAnchor: [12, 41], // Positioning
    popupAnchor: [1, -34], // Popup positioning
    shadowSize: [41, 41], // Shadow size
  })

  return (
    <div className="location-section">
      <MapContainer
        center={[lat, lng]}
        zoom={15}
        style={{ height: '300px', width: '100%', borderRadius: '8px' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={[lat, lng]} icon={customMarker}>
          <Popup>{eventInfo.placeName}</Popup>
        </Marker>
      </MapContainer>
      <h2>
        <T k="eventLocation" />
      </h2>
      <p className="event-address">{eventInfo.placeName}</p>

      <div className="map-buttons">
        <button
          className="map-button google-maps"
          onClick={() => window.open(eventInfo.eventAddress)}
        >
          <FaMapMarkedAlt className="button-icon" fill="white" />
          <T k="googleMaps" />
        </button>

        <button
          className="map-button waze"
          onClick={() => window.open(wazeLink)}
        >
          <FaWaze className="button-icon" fill="white" />
          <T k="waze" />
        </button>
      </div>
    
    </div>
  )
}

export default LocationSection
